module.exports = __webpack_public_path__ + "static/media/thomas-killian.ee5c8fc2.jpg";